import { fetcher } from '@/src/general/utilities/fetcher'
import type { TSignalConfig } from '@/src/general/utilities/fetcher/IFetcher'

import type { TFraternityOnboarding, TFraternityOnboardingPatch } from './fraternityApi.types'

const FRATERNITY_ONBOARDINGS_PATH = '/private/fraternity-onboardings'

export const fraternityApi = {
  getFraternityOnboarding: ({ signal }: TSignalConfig) =>
    fetcher.query<TFraternityOnboarding>(FRATERNITY_ONBOARDINGS_PATH, { signal }),

  patchFraternityOnboarding: (payload: TFraternityOnboardingPatch) =>
    fetcher.mutate<TFraternityOnboarding, TFraternityOnboardingPatch>(FRATERNITY_ONBOARDINGS_PATH, payload, {
      method: 'PATCH',
    }),
}
